<template>
      <div id="name">
            <section class="section intro-hero animate__animated animate__fadeIn">
                  <BackButton link="/intro" />
                  <div class="grid-container max">
                        <div class="intro-hero-grid">
                              <div class="intro-hero-left">
                                    <h1>Welcome</h1>
                              </div>
                              <div class="intro-hero-right">
                                    <p class="intro-hero-lead">What&rsquo;s your first name?</p>
                                    <input v-model="firstName" placeholder="Insert name here" class="name-hero-input" @keyup.enter="storeData()" />
                              </div>
                        </div>
                  </div>
                  <div class="intro-hero-btn-wrap">
                        <button class="intro-hero-btn" @click="storeData()"><span>Next</span></button>
                  </div>
            </section>
      </div>
</template>

<script>
import BackButton from "../components/BackButton"
import gaEventMixin from "../mixins/gaEventMixin"
export default {
      name: "SHBPName",
      data() {
            return {
                  firstName: this.$store.state.firstName,
            }
      },
      methods: {
            storeData() {
                  const firstName = this.firstName
                  if ((!firstName || firstName == "" || firstName.length <= 1)) {
                        let message = 'Please make sure the name you have entered is correct and that all fields have been filled out.'
                        this.$swal({
                              html: message,
                              showCancelButton: false
                        })
                  }
                  else {
                        this.$store.commit("changeName", firstName)
                        this.$router.push("/member")
                        localStorage.setItem("antName", firstName)
                  }
            }
      },
      mounted() {
            window.scrollTo(0, 0)
      },
      components: { BackButton },
      mixins: [gaEventMixin]
}
</script>

<style lang="scss">
#name {
      .intro-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 100px 0;
            position: relative;
            min-height: calc(100vh - 68px);
            display: flex;
            flex-direction: column;
            justify-content: center;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .intro-hero-grid {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  justify-content: space-between;
                  gap: 40px;
            }

            .intro-hero-left {
                  flex: 1 1 400px;
                  max-width: 480px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(4.25rem, 6.5vw, 5.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 0;
                  }
            }

            .intro-hero-right {
                  flex: 1 1 320px;
                  max-width: 400px;
                  text-align: center;

                  .intro-hero-lead {
                        color: #0A2C4C;
                        font-size: 1.25rem;
                        font-weight: 500;
                        line-height: 1.2;
                        margin-bottom: 20px;
                  }

                  .name-hero-input {
                        max-width: 400px;
                        margin: 0 auto;
                        text-align: center;
                        text-transform: uppercase;
                        font-weight: 700;
                        font-size: 1rem !important;
                        color: #12130f;
                        background-color: #ffffff;
                        border: solid 1.5px #0A2C4C;

                        &::placeholder {
                              color: #12130f;
                              opacity: 1;
                        }
                  }
            }

            .intro-hero-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  background-color: #ffffff;
                  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
                  padding: 20px 0;
                  text-align: center;
            }

            .intro-hero-btn {
                  display: block;
                  background-color: #1355E9;
                  color: #ffffff !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 330px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;
                  margin: 0 auto;

                  &:hover {
                        background-color: #44B8F3;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 100px 24px;
                  justify-content: flex-start;

                  .back-btn {
                        left: 2rem;
                  }

                  .intro-hero-grid {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 0;
                  }

                  .intro-hero-left {
                        flex: 0 0 auto;
                        max-width: 100%;

                        h1 {
                              font-size: clamp(2rem, 11vw, 5.25rem) !important;
                        }
                  }

                  .intro-hero-right {
                        flex: 0 0 auto;
                        width: 100%;
                        max-width: 100%;
                        text-align: left;
                        margin-top: 15vh;

                        .intro-hero-lead {
                              font-size: 1.25rem;
                        }

                        .name-hero-input {
                              margin: 0;
                        }
                  }
            }
      }
}
</style>
